import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { IconButton, Grid } from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";

function AssetUsageContent({ dialogState, setDialogState }) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (value) => {
      setDialogState({ operatingHours: value });
    },
    [setDialogState]
  );

  const handleDownValue = useCallback(() => {
    if (dialogState.operatingHours >= 100) setDialogState({ operatingHours: dialogState.operatingHours - 100 });
  }, [dialogState, setDialogState]);

  const handleUpValue = useCallback(() => {
    setDialogState({ operatingHours: dialogState.operatingHours + 100 });
  }, [dialogState, setDialogState]);

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item>
        <IconButton onClick={handleDownValue}>
          <Remove fontSize="small" />
        </IconButton>
      </Grid>
      <Grid item>
        <CustomTextField
          fullWidth
          label={t("Asset.HoursOfOperation")}
          value={dialogState.operatingHours || 0}
          onChange={handleChange}
          isNumeric={true}
        />
      </Grid>
      <Grid item>
        <IconButton onClick={handleUpValue}>
          <Add fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
  );
}

AssetUsageContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
};

export default AssetUsageContent;
